// extracted by mini-css-extract-plugin
export default {"modalBg":"Modal_modalBg__PfU3D","content":"Modal_content__BI8ch","inputs":"Modal_inputs__6r7zu"};